var video = document.getElementById('videoss');


    video.addEventListener('touchstart',function(){
            video.play();
    },false);



jQuery(document).ready(function(){
    //jQuery("#ac-globalnav .ac-gn-item.ac-gn-search").click(function(){
  	jQuery("#ac-globalnav .ac-gn-item.ac-gn-search").click(function(){
      jQuery("nav#ac-globalnav").addClass("searchshow");
      setTimeout(function(){ 
        jQuery("nav#ac-globalnav").removeClass("searchshow");
        jQuery("nav#ac-globalnav").addClass("searchopen");
      },500);
     
    });


  	jQuery("#ac-gn-searchview-close").click(function(){
      jQuery("nav#ac-globalnav").addClass("searchhide");
      setTimeout(function(){ 
        jQuery("nav#ac-globalnav").removeClass("searchhide");
        jQuery("nav#ac-globalnav").removeClass("searchopen");
      }, 500);
      
    });
  
  	jQuery(".ac-gn-menuicon-label").click(function(e){
      //debugger;
      //var checkBoxes = $("input.ac-gn-menustate"); 
     // console.log($('input#ac-gn-menustate:checked').length);
      //checkBoxes.prop("checked", !checkBoxes.prop("checked"));
    //  settimeout
      e.preventDefault();
      if($('input#ac-gn-menustate:checked').length > 0){
      	$('input#ac-gn-menustate').prop("checked",false);
      }else{
      	$('input#ac-gn-menustate').prop("checked",true);
      }
      
    });

  	jQuery('#videoss').get(0).play();
  
});
